import {Component, Inject, OnInit} from '@angular/core';
import {OrderPosition} from "../../../shared/models/OrderPosition";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Item} from "../../../shared/models/item";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Category} from "../../../shared/models/category";
import {PrinterCategoryQueueAssignmentDto} from "../../../shared/models/printer-category-queue-assignment-dto";

@Component({
  selector: 'app-item-details-popup',
  templateUrl: './item-details-popup.component.html',
  styleUrls: ['./item-details-popup.component.scss']
})
export class ItemDetailsPopupComponent implements OnInit {
  item: Item;
  itemForm: FormGroup;
  categories: Category[] = [];
  printCategories: PrinterCategoryQueueAssignmentDto[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<ItemDetailsPopupComponent>) {
    this.item = data.item;
    this.categories = data.categories;
    this.printCategories = data.printCategories;
    this.itemForm = this.formBuilder.group({
      itemNo: [{value: this.item.itemNo, disabled: true}],
      // guid: [this.item.guid, Validators.required],
      name: [this.item.name, Validators.required],
      price: [this.item.price, Validators.required],
      categoryIdentifier: [this.item.categoryIdentifier, Validators.required],
      printCategoryIdentifier: [this.item.printCategoryIdentifier, Validators.required],
      // description: [this.item.description],
      sortId: [{value: this.item.sortId, disabled: data.newItem}, Validators.required],
      infiniteQuantity: [this.item.infiniteQuantity, Validators.required],
      remainingQuantity: [{value: this.item.remainingQuantity, disabled: this.item.infiniteQuantity}],
      enabled: [this.item.enabled, Validators.required],
      // created: [this.item.created, Validators.required],
      // changed: [this.item.changed],
      // createdBy: [this.item.createdBy],
      // changedBy: [this.item.changedBy],
    });

    this.itemForm.get('infiniteQuantity')!.valueChanges.subscribe((infinite: boolean) => {
      const remainingQuantityControl = this.itemForm.get('remainingQuantity');
      if (infinite) {
        remainingQuantityControl?.disable();
      } else {
        remainingQuantityControl?.enable();
      }
    });
  }

  ngOnInit() {
  }

  onSubmit() {
    if (this.itemForm.valid) {
      // get raw value returns all values including disabled (case for infinite quantity)
      const editedItem: Item = this.itemForm.getRawValue();
      this.dialogRef.close(editedItem);
    }
  }
}
